const btc = [{
        coin: 'ETH/BTC',
        vlr: 0.00020255,
        color: 'red',
        updow: '-2.58%'
    },
    {
        coin: 'KCS/BTC',
        vlr: 0.00013192,
        color: 'green',
        updow: '	+5.6%'

    },
    {
        coin: ' XRP/BTC',
        vlr: 0.00002996,
        color: 'red',
        updow: '-1.55% '

    },
    {
        coin: 'VET/BTC',
        vlr: 0.00000103,
        color: 'green',
        updow: '+1.8%'

    },
    {
        coin: ' EOS/BTC',
        vlr: 0.00000103,
        updow: '-2.05%',
        color: 'red',

    },
    {
        coin: ' BTT/BTC',
        vlr: 0.00002303,
        color: 'red',
        updow: '-1.05% '

    },
    {
        coin: 'LTC/BTC',
        vlr: 0.03520103,
        color: 'green',
        updow: '+1.5%'

    },
    {
        coin: ' TRX/BTC',
        vlr: 0.00330103,
        color: 'red',
        updow: '-3.05% '

    }, {
        coin: 'BSV/BTC',
        vlr: 0.00300103,
        color: 'green',
        updow: '+2.05%'

    }, {
        coin: 'COTI/BTC',
        vlr: 0.003500103,
        color: 'green',
        updow: '+2.85%'

    }, {
        coin: ' XYT/BTC',
        color: 'green',
        vlr: 0.00003103,
        updow: '+3.55%'

    }, {
        coin: ' BNB/BTC',
        vlr: 0.003500103,
        color: 'red',
        updow: '-2.05% '

    }, {
        coin: 'XMR/BTC',
        vlr: 0.003500103,
        color: 'red',
        updow: '-1.05%'

    }, {
        coin: ' TRY/BTC',
        vlr: 0.00000123,
        color: 'red',
        updow: '-2.05%'
    }, {
        coin: 'ADA/BTC',
        vlr: 0.00050103,
        color: 'green',
        updow: '+5.05% '

    }
]

export default btc